const menuData = [
  {
    id: 1,
    title: 'Жизнь Fitron',
    link: false,
    list: [
      {
        id: 3,
        title: 'Отзывы',
        link: 'https://fitron.club/reviews/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 4,
        title: 'Присоединиться',
        link: 'https://fitron.club/join/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 5,
        title: 'Правила клуба',
        link: 'https://fitron.club/club-rules/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 6,
        title: 'Правила безопасности',
        link: 'pravila-tehniki-bezopasnosti.pdf',
        new_window: true,
        anchor: false,
        anchorSection: null,
        type: 'document',
      },
      {
        id: 8,
        title: 'Правила программы лояльности',
        link: 'loyalty_program_fitron.pdf',
        new_window: true,
        anchor: false,
        anchorSection: null,
        type: 'document',
      }
    ]
  },
  {
    id: 2,
    title: 'Клубы',
    link: 'https://fitron.club/clubs/?from=tariff',
    list: [
      {
        id: 1,
        title: 'FITRON Газетный',
        link: 'https://fitron.club/clubs/gazetny/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 2,
        title: 'FITRON Горизонт',
        link: 'https://fitron.club/clubs/gorizont/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 3,
        title: 'FITRON Миллениум',
        link: 'https://fitron.club/clubs/millenium/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 4,
        title: 'FITRON Орбита',
        link: 'https://fitron.club/clubs/orbita/',
        new_window: false,
        anchor: false,
        anchorSection: null
      }
    ]
  },
  {
    id: 3,
    title: 'Поддержка',
    link: false,
    list: [
      {
        id: 1,
        title: 'Тарифы',
        link: '/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      /*
      {
        id: 2,
        title: 'Фитнес-навигатор',
        link: 'https://free.fitron.club',
        new_window: true,
        anchor: false,
        anchorSection: null
      },
       */
      {
        id: 3,
        title: 'Вопросы и ответы',
        link: 'https://fitron.club/support/qa/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 4,
        title: 'Блог',
        link: 'https://fitron.club/support/blog/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 5,
        title: 'Контакты',
        link: 'https://fitron.club/contacts/',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 6,
        title: 'Способы оплаты',
        link: 'https://fitron.club/payment/',
        new_window: false,
        anchor: false,
        anchorSection: null
      }
    ]
  },
  {
    id: 4,
    title: 'Фитнес',
    link: 'https://fitron.club/fitness/',
    list: [
      {
        id: 1,
        title: 'Расписание',
        link: 'https://fitron.club/fitness/raspisanie/?from=tariff',
        new_window: false,
        anchor: false,
        anchorSection: null
      },
      {
        id: 5,
        title: 'Детский фитнес',
        //link: '/fitness/detsky-fitness/',
        link: 'https://space.fitron.club/shkolatorium',
        new_window: true,
        anchor: false,
        anchorSection: null
      },
      {
        id: 6,
        title: 'Тренеры',
        link: 'https://fitron.club/fitness/trainers/',
        new_window: false,
        anchor: false,
        anchorSection: null
      }
    ]
  }
];

export default menuData;
